import React from 'react'
import styled from 'styled-components';
import { Button } from './styles/Button';
import { NavLink } from 'react-router-dom';

function ErrorPage() {
  return (
    <>
    <Wrapper>
      <div className='container'>
        <div>
          <h2>404</h2>
          <h3>OH! You are lost</h3>
          <p>The page you are looking for does not exist. Click the button down below to get back to Home page</p>
        </div>
        <Button>
          <NavLink to="/">
             Back to Home
          </NavLink>
        </Button>
      </div>
    </Wrapper>
    </>
  )
}
const Wrapper = styled.section`
  .container {
    padding: 9rem 0;
    text-align: center;

    h2 {
      font-size: 10rem;
    }

    h3 {
      font-size: 4.2rem;
    }

    p {
      margin: 2rem 0;
    }
  }
`;
export default ErrorPage